import {
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonImg,
  IonText,
} from '@ionic/react';

import ArrowLeft from '@/assets/imgs/arrow-left.svg';
import LoginKeys from '@/components/auth/LoginKeys/LoginKeys';

import styles from './LoginPassword.module.scss';

interface LoginPasswordProps {
  backBtn: () => void;
  username: string;
  resentPassword: () => void;
  loginError: (unexpected?: boolean) => void;
  biometryUsernameMismatch: boolean;
}

export default function LoginPassword({
  backBtn,
  username,
  resentPassword,
  loginError,
  biometryUsernameMismatch,
}:LoginPasswordProps) {
  return (
    <>
      <IonCardHeader mode="md">
        <IonCardSubtitle
          className={styles.LoginPasswordHeaderSubtitleBackarrow}
          onClick={backBtn}
        >
          <IonImg
            src={ArrowLeft}
            className={styles.LoginPasswordHeaderSubtitleBack}
          />
          <IonText className={styles.LoginPasswordHeaderSubtitleText}>
            Atrás
          </IonText>
        </IonCardSubtitle>
        <IonCardTitle className={styles.LoginPasswordHeaderTitle} mode="md">
          Introduce tu clave
        </IonCardTitle>
        <IonCardSubtitle className={styles.LoginPasswordHeaderSubtitle} mode="md">
          Introduce los 6 dígitos de tu clave
        </IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <LoginKeys
          username={username}
          resentPassword={resentPassword}
          loginError={loginError}
          biometryUsernameMismatch={biometryUsernameMismatch}
        />
      </IonCardContent>
    </>
  );
}
